<template>
  <div>
    <div class="pb-3">
      <router-link :to="{ name: 'activist_tasks' }">Назад к списку задач</router-link>
    </div>
    <Task :course-id="$route.params.id" @task-update="taskUpdate"></Task>
  </div>
</template>

<script>
import Task from '@/components/activist/Task'

export default {
  name: 'activist_task_create_edit',
  components: { Task },
  methods: {
    taskUpdate(task) {
      if (!this.$route.params.id) {
        this.$router.push({ name: 'activist_task_edit', params: { id: task.id } })
      }
    },
  },
}
</script>
